// init.ts used to initialize Billing domain components on startup.

import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { PrivateBillSharedItemProvider } from "./Services/PrivateBilling/PrivateBillSharedItemProvider";

sharedItemProviderFactory.registerProvider(PortalLinkedItemType.PrivateBill, new PrivateBillSharedItemProvider());
